import React from "react";
import styled, { css } from "styled-components";
import { ScrollLink } from "react-scroll";
import Link from "gatsby-link";

import Logo from "./Logo";
import Menu from "./Menu";
import MenuItem from "./MenuItem";
import Button from "./Button";

import colors from "../config/colors";
import media from "../config/mediaQueries";

const fixedMenuCss = css`
  background: ${colors.yellow};
  height: 5rem;
  box-shadow: 0px 4px 17px -2px rgba(0, 0, 0, 0.25);
`;

const MenuBar = styled.div`
  width: 100%;
  height: 8rem;
  position: fixed;
  z-index: 100;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
  transition: 200ms all ease-out;
  height: 12rem;
  ${({ fixed }) => fixed && fixedMenuCss};
  ${media.desktop`
    background: transparent;
    height: 5rem;
    ${({ fixed }) => fixed && fixedMenuCss};
  `};
`;

const fixedContactButtonCss = css`
  right: 1rem;
  transition-delay: 200ms;
`;

const ContactButton = styled.span`
  position: absolute;
  top: 1rem;
  transition: 200ms all cubic-bezier(0.25, 0.92, 0.66, 1.08);
  right: -8rem;
  transition-delay: 0ms;
  ${({ fixed }) => fixed && fixedContactButtonCss};
`;

const ScrollButton = ScrollLink(Button);

const DEFAULT_BUTTON = (
  <ScrollButton
    type="primary"
    to="contact"
    smooth={true}
    offset={-50}
    href="#contact"
  >
    Kontakt
  </ScrollButton>
);

export default ({ fixed, button = DEFAULT_BUTTON }) => (
  <MenuBar fixed={fixed}>
    <Link to="/">
      <Logo fixed={fixed} />
    </Link>

    <ContactButton fixed={fixed}>{button}</ContactButton>
  </MenuBar>
);



// WEBPACK FOOTER //
// ./src/components/MenuBar.js